<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import InputField from '@js/components/fields/InputField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormLegend from '@js/components/forms/FormLegend.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { toastError } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const props = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    ids: {
        type: Array,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isOpen = ref(false);

const isSubmitting = ref(false);

const form = reactive({
    scheduledAt: '',
});

const validationSchema = object({
    scheduledAt: string().required('Ce champ est obligatoire.'),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.projectManagement.smo.postReschedulePosts', {
                tenant: props.tenant.id,
            }),
            {
                ids: props.ids,
                scheduledAt: form.scheduledAt,
            },
        )
        .then(() => {
            isOpen.value = false;

            if (props.callback) {
                props.callback();
            }

            form.scheduledAt = '';
        })
        .catch((error) => {
            toastError(error);
        })
        .finally(() => {
            isSubmitting.value = false;
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Replanifier les publications </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <FormLegend>
                            {{ props.ids.length }} publication(s)
                            sélectionnée(s). Les publications déjà publiées ou
                            en cours de publication seront ignorées.
                        </FormLegend>

                        <InputField
                            v-model="form.scheduledAt"
                            label="Nouvelle date de publication"
                            field-name="scheduledAt"
                            field-id="scheduledAt"
                            type="datetime-local"
                            required
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    submit-text="Replanifier"
                    submitting-text="Replanification en cours..."
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
